// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__3Bf58","dark":"Footer_dark__2U_mV","inner":"Footer_inner__1Dcz3"};